import { datadogClientAxiosErrorHandler } from '@mathflat/shared/@modules/datadog/axiosHandler'
import { DatadogClient } from '@mathflat/shared/@modules/datadog/datadogClient'
import { AxiosError } from 'axios'

import { ERROR_CODE } from '@/constant/errorCode'
import { envUtils } from '@/utils/envUtils'

const datadogDebug = localStorage.getItem('DATADOG_DEBUG') ?? false

const DATADOG_IGNORE_ERROR_CODES = [
  {
    url: '/favorite',
    method: 'post',
    status: 400,
    code: ERROR_CODE.FAVORITE_PROBLEM_CREATION_NOT_ALLOWED,
  },
  {
    url: '/worksheet/filter',
    method: 'get',
    status: 400,
    code: 'WORKSHEET_NOT_FOUND',
  },
  {
    url: '/login',
    method: 'post',
    status: 400,
  },
  {
    url: '/password/reset-token',
    method: 'post',
    status: 400,
  },
  {
    status: 400,
    code: 'WRONG_REQUEST_CURRICULUM_GROUP',
  },
]

class TeacherDatadogClient extends DatadogClient {
  axiosErrorHandler = datadogClientAxiosErrorHandler(this)

  constructor() {
    super({
      enabled:
        envUtils.isLive &&
        import.meta.env.VITE_BRAND !== 'schoolflat' &&
        import.meta.env.VITE_DATADOG_ENABLED === 'true',
      debug: datadogDebug,
      networkErrorsToIgnore: DATADOG_IGNORE_ERROR_CODES,
      errorMessagesToIgnore: [/인증에 필요한 정보가 부족합니다/],
      config: {
        applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
        env: import.meta.env.VITE_VERCEL_ENV,
        version: import.meta.env.VITE_DATADOG_RELEASE_VERSION,
      },
    })
  }

  override sendError = (
    error: Error | AxiosError,
    context?: Parameters<DatadogClient['sendError']>[1],
  ) => {
    if (error instanceof AxiosError) {
      return this.axiosErrorHandler(error, context)
    }
    return super.sendError(error, context)
  }
}

export const datadogClient = new TeacherDatadogClient()
